import React from "react";
import "./Explore.css";
const Explore = () => {
  return (
    <>
      <div class="res">
        <div class="text result">
          <h2 class="primary mb">⁠Results of our services</h2>
        </div>
        <div className="res__img">
          <img src="https://i.imgur.com/s7XwGV4.jpeg" alt="" />
          <img src="https://i.imgur.com/zeAfsh5.jpeg" alt="" />
          <img src="https://i.imgur.com/wxGwxYA.jpeg" alt="" />

          {/* <img src="https://i.imgur.com/8GrLJyy.jpeg" alt="" /> */}

          <img src="https://i.imgur.com/KXao2vw.jpeg" alt="" />
          {/* <img src="https://i.imgur.com/ua35Qkw.jpeg" alt="" /> */}
          <img src="https://i.imgur.com/n7LnQgO.jpeg" alt="" />
          <img
            src="https://i.imgur.com/oHFbWho.png
"
            alt=""
          />

          <img
            src="  https://i.imgur.com/SLOR93X.png
"
            alt=""
          />
        </div>
      </div>
    </>
  );
};

export default Explore;
